/** Shimmer placeholder for loading states. */

interface SkeletonProps {
  width?: string;
  height?: string;
  className?: string;
}

export function Skeleton({ width = '100%', height = '1rem', className }: SkeletonProps) {
  return (
    <div
      className={`skeleton${className ? ` ${className}` : ''}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

/** Pre-built skeleton for a KPI grid (3 items). */
export function KpiGridSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="react-kpi-grid">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="react-kpi">
          <Skeleton width="60%" height="0.75rem" />
          <Skeleton width="40%" height="1.5rem" className="skeleton--mt" />
          <Skeleton width="80%" height="0.65rem" className="skeleton--mt" />
        </div>
      ))}
    </div>
  );
}

/** Pre-built skeleton for a list of items. */
export function ListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="ops-list">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="ops-list__item">
          <div style={{ flex: 1 }}>
            <Skeleton width="50%" height="0.85rem" />
            <Skeleton width="70%" height="0.65rem" className="skeleton--mt" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Full-page loading skeleton matching dashboard layout. */
export function DashboardSkeleton() {
  return (
    <div className="page-stack">
      <Skeleton width="30%" height="1.5rem" />
      <div className="priority-grid-react">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="priority-card-react priority-card-react--skeleton">
            <Skeleton width="2rem" height="2rem" className="skeleton--circle" />
            <div style={{ flex: 1 }}>
              <Skeleton width="60%" height="0.8rem" />
              <Skeleton width="40%" height="0.65rem" className="skeleton--mt" />
            </div>
          </div>
        ))}
      </div>
      <KpiGridSkeleton count={3} />
    </div>
  );
}
